<template>
    <div>
        <div v-if="!loading" class="web-background font-sans relative z-40">
            <Header />
            <vue-page-transition name="fade">
                <router-view :config="webConfig" class="relative mt-[72px] md:mt-[116px] min-h-[500px]" />
            </vue-page-transition>
            <Footer :config="webConfig.config" />
        </div>
        <div v-show="!hideSplashScreen"
            class="w-screen h-screen bg-white overflow-hidden absolute top-0 left-0 z-50 transition-all duration-1000" 
            :class="{'-translate-y-full':!loading, 'fade-splash':hideSplashScreen}">
            <Loading class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
        </div>
    </div>
</template>
    
<script>
import { mapActions } from 'vuex'
import Header from '@/components/user/header-user'
import Footer from '@/components/user/footer-user'
import Loading from '@/components/page-loading'
import AOS from 'aos';

export default {
    name: 'index',
    components: {
        Header,
        Footer,
        Loading
    },
    data() {
        return {
            webConfig: {},
            loading: true,
            changePage: true,
            hideSplashScreen: false
        }
    },
    methods: {
        ...mapActions('webConfig', ['GetWebConfigList']),
    },
    async created() {
        AOS.init();
        const response = await this.GetWebConfigList()
        if (response.code == 200) {
            this.webConfig = response.data
            if (response.data.isMaintain) {
                this.$router.push({path: 'maintain'})
            }
            setTimeout(()=>{
                this.loading = false
                setTimeout(()=>{
                    this.hideSplashScreen = true
                }, 1000)
            }, 800)
        }
    },
};
</script>
    
<style>
.web-background {
    background-color: white;
}
div {
    font-family: gil;
}
a {
    text-decoration: none !important;
}
html {
    scroll-behavior: smooth;
}
.image_hover:hover {
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
}

.image_hover {
    -webkit-transition: all 0.7s ease;
    transition: all 0.7s ease;
}
</style>
<style scoped>
.fade-splash {
  animation: fadeOut 0.5s ease-in-out forwards;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
    